/* Vult het "Size chart"-accordeon op de PDP met de echte grading uit
   assets/quotrell-size-charts.js (dezelfde bron als de fit-quiz).
   Per productcategorie een eigen lijntekening waarin A/B/C aanwijzen waar
   gemeten is. Valt terug op het plaatje uit custom.size_chart als er geen tabel is. */
(function () {
  var STIJL = '\
.qtl-sc{font-family:Helvetica,Arial,sans-serif;color:#000;width:100%}\
.qtl-sc-bar{display:flex;align-items:center;justify-content:flex-end;gap:14px;margin:0 0 10px;font-size:12px}\
.qtl-sc-bar button{background:none;border:0;padding:0;font:inherit;color:#9b9894;cursor:pointer}\
.qtl-sc-bar button.aan{color:#000;font-weight:700}\
.qtl-sc-wrap{overflow-x:auto;-webkit-overflow-scrolling:touch}\
.qtl-sc table{width:100%;border-collapse:collapse;font-size:12.5px}\
.qtl-sc th,.qtl-sc td{text-align:center;padding:12px 6px;background:#f7f7f7;border-bottom:2px solid #fff;border-right:2px solid #fff;white-space:nowrap}\
.qtl-sc th:first-child,.qtl-sc td:first-child{text-align:left;padding-left:12px;min-width:118px;white-space:normal}\
.qtl-sc thead th{font-weight:400;color:#555}\
.qtl-sc thead th.maat{cursor:pointer;font-weight:700;color:#000}\
.qtl-sc thead th.maat:hover{background:#ececec}\
.qtl-sc .aan{background:#e2e2e2}\
.qtl-sc thead th.maat.aan{text-decoration:underline}\
.qtl-sc th.uit,.qtl-sc td.uit{color:#b9b6b2}\
.qtl-sc-ltr{display:inline-block;vertical-align:1px;border:1px solid #000;border-radius:999px;min-width:16px;height:16px;\
line-height:15px;font-size:9px;font-weight:700;text-align:center;margin-right:6px}\
.qtl-sc-fig{position:relative;display:block;margin:0 auto 16px;max-width:250px;width:100%}\
.qtl-sc-fig.qtl-sc-foto{aspect-ratio:1/1}\
.qtl-sc-fig img{width:100%;height:auto;display:block}\
.qtl-sc-marks{position:absolute;inset:0;width:100%;height:100%}\
.qtl-sc-fig svg{width:100%;height:auto;display:block}\
.qtl-sc-note{margin:12px 0 0;font-size:11px;color:#999}\
.qtl-sc-kop{margin:0 0 10px;font-size:11px;font-weight:700;letter-spacing:.08em;text-transform:uppercase}\
.qtl-sc-scheiding{height:1px;background:#e6e6e6;margin:26px 0 20px}\
.qtl-sc-atc{display:block;width:100%;margin:18px 0 0;padding:16px 10px;border:0;font:inherit;font-size:13px;\
letter-spacing:.02em;cursor:pointer;background:#000;color:#fff}\
.qtl-sc-atc[disabled]{background:#f2f2f2;color:#8a8a8a;cursor:default}\
.qtl-sc-model{margin:22px 0 0;border-top:1px solid #e6e6e6;padding-top:16px}\
.qtl-sc-model b{display:block;font-size:13px;margin-bottom:5px}\
.qtl-sc-model span{font-size:12.5px;color:#6b6864}\
@media(max-width:520px){.qtl-sc th,.qtl-sc td{font-size:11.5px;padding:10px 5px}\
.qtl-sc th:first-child,.qtl-sc td:first-child{min-width:104px}.qtl-sc-fig{max-width:185px}}';

  function stijl() {
    if (document.getElementById('qtl-sc-stijl')) return;
    var s = document.createElement('style');
    s.id = 'qtl-sc-stijl';
    s.textContent = STIJL;
    document.head.appendChild(s);
  }

  function getal(n) {
    if (n === null || n === undefined || n === '') return '-';
    return String(n).replace('.', ',');
  }

  /* ---------- tekeningen ----------
     Eén assenstelsel voor alles: viewBox 4 0 240 228.
     Zoom y212, schouder y34, oksel y88, lijf 70..170, oksellijn 84..156. */
  var L = 'fill="none" stroke="#000" stroke-width="2.2" stroke-linejoin="round" stroke-linecap="round"';
  var R = 'fill="none" stroke="#000" stroke-width="1.3" stroke-linejoin="round"';
  var H = 'fill="none" stroke="#000" stroke-width="1" stroke-dasharray="3 3"';
  var pad = function (d, s) { return '<path ' + (s || L) + ' d="' + d + '"/>'; };

  // doorlopende omtrek: mouwen zitten vast aan het lijf
  var LANG = pad('M98 30C98 41 142 41 142 30L157 34L198 56L188 152L164 148L156 88L170 212H70L84 88' +
                 'L76 148L52 152L42 56L83 34Z');
  var KORT = pad('M98 30C98 41 142 41 142 30L157 34L196 52L186 102L162 98L156 88L170 212H70L84 88' +
                 'L78 98L54 102L44 52L83 34Z');
  var MOUWLOOS = pad('M98 30C98 41 142 41 142 30L153 36L156 88L170 212H70L84 88L87 36Z');
  var BOXY = pad('M96 30C96 42 144 42 144 30L160 35L200 58L190 154L166 150L158 88L174 212H66L82 88' +
                 'L74 150L50 154L40 58L80 35Z');
  var BODYSUIT = pad('M98 30C98 41 142 41 142 30L157 34L198 56L188 152L164 148L156 88L165 166' +
                     'c0 18-13 30-30 30h-30c-17 0-30-12-30-30L84 88L76 148L52 152L42 56L83 34Z');

  var CAPUCHON = pad('M97 31C94 7 146 7 143 31');
  var RITS = pad('M120 36v176', R);
  var KOORD = pad('M112 38v20M128 38v20', R);
  var RIB_ZOOM = pad('M72 196h96', R);
  var RIB_MOUW = pad('M166 140l21 4M74 140l-21 4', R);
  var KRAAG = pad('M100 30L112 48L120 42L128 48L140 30');
  var PLACKET = pad('M112 44v42M128 44v42', R);
  var KNOOPRIJ = pad('M120 46v150', R) +
    '<circle cx="120" cy="70" r="2.2" fill="#000"/><circle cx="120" cy="104" r="2.2" fill="#000"/>' +
    '<circle cx="120" cy="138" r="2.2" fill="#000"/><circle cx="120" cy="172" r="2.2" fill="#000"/>';

  var BROEK = pad('M70 22h100v24l-9 164h-35l-6-104-6 104H79l-9-164z');
  var BROEK_KORT = pad('M70 22h100v24l-5 98h-38l-7-58-7 58H75l-5-98z');
  var BAND = pad('M70 46h100', R);
  var ZAKKEN = pad('M78 48c9 11 19 15 27 15M162 48c-9 11-19 15-27 15', R);

  var A_LANG = {
    chest:    { p: [220, 92],  hulp: pad('M84 92h126', H) },
    length:   { p: [120, 158], hulp: pad('M120 40v172', H) },
    sleeve:   { p: [20, 178],  hulp: pad('M120 28L83 34L47 104L64 150L30 178', H) },
    waist:    { p: [220, 158], hulp: pad('M70 158h140', H) },
    shoulder: { p: [120, 10],  hulp: pad('M83 26h74', H) }
  };
  var A_KORTE_MOUW = {
    chest:    { p: [220, 92],  hulp: pad('M84 92h126', H) },
    length:   { p: [120, 158], hulp: pad('M120 40v172', H) },
    sleeve:   { p: [20, 112],  hulp: pad('M120 28L83 34L49 78L66 100L30 112', H) },
    waist:    { p: [220, 158], hulp: pad('M70 158h140', H) },
    shoulder: { p: [120, 10],  hulp: pad('M83 26h74', H) }
  };
  var A_MOUWLOOS = {
    chest:    { p: [220, 92],  hulp: pad('M84 92h126', H) },
    length:   { p: [120, 158], hulp: pad('M120 40v172', H) },
    waist:    { p: [20, 158],  hulp: pad('M30 158h140', H) },
    shoulder: { p: [120, 10],  hulp: pad('M87 30h66', H) }
  };
  var A_BROEK = {
    waist:  { p: [220, 34],  hulp: pad('M70 34h140', H) },
    crotch: { p: [120, 72],  hulp: pad('M120 22v84', H) },
    length: { p: [20, 116],  hulp: pad('M30 22v188M30 22h40M30 210h49', H) },
    knee:   { p: [220, 140], hulp: pad('M79 140h131', H) }
  };
  var A_KORT = {
    waist:  { p: [220, 34],  hulp: pad('M70 34h140', H) },
    crotch: { p: [120, 66],  hulp: pad('M120 22v72', H) },
    length: { p: [20, 86],   hulp: pad('M30 22v122M30 22h40M30 144h45', H) },
    knee:   { p: [220, 110], hulp: pad('M75 110h135', H) }
  };

  var V = {};
  function zet(namen, body, ankers) {
    namen.forEach(function (n) { V[n] = { body: body, ankers: ankers }; });
  }
  zet(['LONG SLEEVE'], LANG, A_LANG);
  zet(['T-SHIRTS', 'T-SHIRT', 'TEES'], KORT, A_KORTE_MOUW);
  zet(['KNITWEAR', 'SWEATER', 'CREWNECK'], LANG + RIB_ZOOM + RIB_MOUW, A_LANG);
  zet(['HOODIES', 'HOODIE'], CAPUCHON + LANG + RIB_ZOOM + RIB_MOUW + KOORD, A_LANG);
  zet(['ZIP HOODIE'], CAPUCHON + LANG + RIB_ZOOM + RIB_MOUW + RITS, A_LANG);
  zet(["POLO'S", 'POLO'], KRAAG + LANG + PLACKET, A_LANG);
  zet(['SHIRTS', 'SHIRT'], KRAAG + LANG + KNOOPRIJ, A_LANG);
  zet(['JACKETS', 'JACKET'], BOXY + RITS, A_LANG);
  zet(['TOPS', 'TOP'], MOUWLOOS, A_MOUWLOOS);
  zet(['BODYSUITS', 'BODYSUIT'], BODYSUIT, A_LANG);
  zet(['PANTS', 'PANTALON'], BROEK + BAND, A_BROEK);
  zet(['JEANS', 'DENIM'], BROEK + BAND + ZAKKEN, A_BROEK);
  zet(['SHORTS'], BROEK_KORT + BAND, A_KORT);
  zet(['SWIMSHORTS', 'SWIMWEAR'], BROEK_KORT + BAND + KOORD, A_KORT);

  function vormVoor(c) {
    var type = ((window.QSQ_PRODUCT && window.QSQ_PRODUCT.type) || '').toUpperCase().trim();
    if (V[type]) return V[type];
    var treffer = Object.keys(V).filter(function (k) { return type.indexOf(k) >= 0; })[0];
    if (treffer) return V[treffer];
    if (c.g === 'bottom') return V.PANTS;
    return (c.cols || []).join(' ').toLowerCase().indexOf('sleeve') >= 0 ? V['LONG SLEEVE'] : V.TOPS;
  }

  function anker(naam) {
    var n = (naam || '').toLowerCase();
    if (n.indexOf('sleeve') >= 0) return 'sleeve';
    if (n.indexOf('chest') >= 0 || n.indexOf('bust') >= 0) return 'chest';
    if (n.indexOf('crotch') >= 0 || n.indexOf('rise') >= 0) return 'crotch';
    if (n.indexOf('waist') >= 0) return 'waist';
    if (n.indexOf('shoulder') >= 0) return 'shoulder';
    if (n.indexOf('knee') >= 0) return 'knee';
    if (n.indexOf('length') >= 0) return 'length';
    return null;
  }

  function bal(p, letter) {
    return '<circle cx="' + p[0] + '" cy="' + p[1] + '" r="10" fill="#fff" stroke="#000" stroke-width="1.1"/>' +
      '<text x="' + p[0] + '" y="' + (p[1] + 3.6) + '" text-anchor="middle" font-size="11" ' +
      'font-family="Helvetica,Arial,sans-serif" font-weight="700" fill="#000">' + letter + '</text>';
  }

  function foto(c, handle) {
    return window.QTL_SC_FIGHTML ? window.QTL_SC_FIGHTML(c.cols, c.g, handle) : null;
  }

  function tekening(c, letters) {
    var v = vormVoor(c), lijnen = '', ballen = '', gebruikt = {};
    (c.cols || []).forEach(function (naam, i) {
      var a = anker(naam), def = a && v.ankers[a];
      if (!def || gebruikt[a]) return;
      gebruikt[a] = true;
      lijnen += def.hulp || '';
      ballen += bal(def.p, letters[i]);
    });
    return '<svg viewBox="4 0 240 228" aria-hidden="true">' + lijnen + v.body + ballen + '</svg>';
  }

  /* ---------- maatkeuze op de pagina ---------- */
  function maatInputs() {
    var alle = [].slice.call(document.querySelectorAll('input[type=radio][name*="options[Size]"]'));
    var hoofd = alle.filter(function (i) { return /mainproduct/i.test(i.name || ''); });
    return hoofd.length ? hoofd : alle;
  }
  /* Het thema vinkt standaard de eerste maat aan. Zolang de bezoeker zelf nog
     niets koos tonen we geen maat, anders lijkt er al iets gekozen te zijn. */
  var zelfGekozen = /[?&]variant=/.test(location.search);
  function gekozenMaat() {
    if (!zelfGekozen) return null;
    var g = maatInputs().filter(function (i) { return i.checked; })[0];
    return g ? String(g.value).trim().toUpperCase() : null;
  }
  function kiesMaat(maat) {
    var i = maatInputs().filter(function (x) { return String(x.value).trim().toUpperCase() === maat; })[0];
    if (!i || i.disabled) return;
    var lbl = document.querySelector('label[for="' + i.id + '"]');
    if (lbl) lbl.click(); else { i.checked = true; i.dispatchEvent(new Event('change', { bubbles: true })); }
  }
  function uitverkocht(maat) {
    var i = maatInputs().filter(function (x) { return String(x.value).trim().toUpperCase() === maat; })[0];
    return !!(i && (i.disabled || /sold-?out/i.test(i.className)));
  }
  function echteKnop() {
    return [].slice.call(document.querySelectorAll('form[action*="/cart/add"] .add--cart'))
      .filter(function (b) { return b.offsetParent; })[0];
  }
  function prijs() {
    var k = echteKnop();
    var m = k && (k.textContent || '').match(/[€$£]\s?[\d.,]+/);
    return m ? m[0].replace(/\s/g, ' ') : '';
  }

  var EENHEID = 'cm';
  try { EENHEID = localStorage.getItem('qtl-sc-eenheid') || 'cm'; } catch (e) {}
  function toon(v) {
    if (v === null || v === undefined || v === '') return '-';
    var n = Number(v);
    if (isNaN(n)) return String(v);
    if (EENHEID === 'in') n = Math.round(n / 2.54 * 10) / 10;
    return String(n).replace('.', ',');
  }

  function blok(c, handle, titel) {
    var letters = ['A', 'B', 'C', 'D', 'E'];
    var maten = Object.keys(c.rows);
    var gekozen = gekozenMaat();
    var fh = window.QTL_SC_FIGHTML && window.QTL_SC_FIGHTML(c.cols, c.g, handle);
    var h = titel ? '<h4 class="qtl-sc-kop">' + titel + '</h4>' : '';
    if (fh) h += '<div class="qtl-sc-fig qtl-sc-foto">' + fh + '</div>';

    h += '<div class="qtl-sc-wrap"><table><thead><tr><th>Size</th>';
    maten.forEach(function (m) {
      var uit = uitverkocht(m);
      h += '<th class="maat' + (m === gekozen ? ' aan' : '') + (uit ? ' uit' : '') +
        '" data-maat="' + m + '">' + m + '</th>';
    });
    h += '</tr></thead><tbody>';
    (c.cols || []).forEach(function (naam, i) {
      h += '<tr><td>' + (fh ? '<span class="qtl-sc-ltr">' + (letters[i] || '') + '</span>' : '') + naam + '</td>';
      maten.forEach(function (m) {
        var r = c.rows[m] || [];
        h += '<td class="' + (m === gekozen ? 'aan' : '') + (uitverkocht(m) ? ' uit' : '') + '">' + toon(r[i]) + '</td>';
      });
      h += '</tr>';
    });
    return h + '</tbody></table></div>';
  }

  function bouw(c, handle) {
    var q = window.QSQ_CHARTS, set = q && q.bySet && q.bySet[handle];
    var h = '<div class="qtl-sc-bar"><button data-e="in"' + (EENHEID === 'in' ? ' class="aan"' : '') + '>Inches</button>' +
            '<button data-e="cm"' + (EENHEID === 'cm' ? ' class="aan"' : '') + '>Centimetres</button></div>';
    if (set && q.list[set.t] && q.list[set.b]) {
      h += blok(q.list[set.t], set.ht, set.nt || 'Top') +
           '<div class="qtl-sc-scheiding"></div>' +
           blok(q.list[set.b], set.hb, set.nb || 'Pants');
    } else {
      h += blok(c, handle, null);
    }
    h += '<p class="qtl-sc-note">All measurements are taken with the garment laid flat.</p>';

    var maat = gekozenMaat();
    h += '<button type="button" class="qtl-sc-atc"' + (maat ? '' : ' disabled') + '>' +
      (maat ? 'Add to cart · ' + maat + (prijs() ? ' · ' + prijs() : '') : 'Select your size') +
      '</button>';

    var model = (window.QSQ_PRODUCT && window.QSQ_PRODUCT.model) || '';
    if (model) h += '<div class="qtl-sc-model"><b>Model measurements</b><span>' + model + '</span></div>';
    return h;
  }

  /* ---------- gedrag ---------- */
  function koppel(doos, c, handle) {
    doos.addEventListener('click', function (e) {
      var eh = e.target.closest('.qtl-sc-bar button');
      if (eh) {
        EENHEID = eh.getAttribute('data-e');
        try { localStorage.setItem('qtl-sc-eenheid', EENHEID); } catch (er) {}
        doos.innerHTML = bouw(c, handle);
        return;
      }
      var th = e.target.closest('th.maat');
      if (th) {
        if (th.classList.contains('uit')) return;
        zelfGekozen = true;
        kiesMaat(th.getAttribute('data-maat'));
        setTimeout(function () { doos.innerHTML = bouw(c, handle); }, 60);
        return;
      }
      var atc = e.target.closest('.qtl-sc-atc');
      if (atc && !atc.disabled) {
        var k = echteKnop();
        if (k) k.click();
      }
    });
    maatInputs().forEach(function (i) {
      i.addEventListener('change', function () {
        zelfGekozen = true;
        doos.innerHTML = bouw(c, handle);
      });
    });
  }

  function vul() {
    var doos = document.querySelector('.qtl-sc[data-handle]');
    if (!doos || doos.dataset.klaar) return true;
    var q = window.QSQ_CHARTS, handle = doos.getAttribute('data-handle'), c = null;
    if (q && q.byHandle && q.byHandle[handle] != null) c = q.list[q.byHandle[handle]];
    if (!c && q && q.bySet && q.bySet[handle]) c = q.list[q.bySet[handle].t];
    var li = doos.closest('li');
    if (c && c.rows && Object.keys(c.rows).length) {
      stijl();
      doos.innerHTML = bouw(c, handle);
      doos.dataset.klaar = '1';
      koppel(doos, c, handle);
      if (li) {
        li.querySelectorAll('.qtl-sc-img, .qtl-sc-alt').forEach(function (el) { el.remove(); });
        li.removeAttribute('hidden');
      }
      return true;
    }
    if (li && li.querySelector('.qtl-sc-img')) li.removeAttribute('hidden');
    return !!q;
  }

  function voorladen() {
    var doos = document.querySelector('.qtl-sc[data-handle]');
    var f = doos && (window.QTL_SC_FIG || {})[doos.getAttribute('data-handle')];
    if (!f || document.getElementById('qtl-sc-pre')) return;
    var l = document.createElement('link');
    l.id = 'qtl-sc-pre'; l.rel = 'preload'; l.as = 'image'; l.href = f.u + '?width=600';
    document.head.appendChild(l);
  }

  function start() {
    if (vul()) { voorladen(); return; }
    var n = 0, t = setInterval(function () {
      if (vul()) { voorladen(); clearInterval(t); } else if (++n > 40) clearInterval(t);
    }, 150);
    var doos = document.querySelector('.qtl-sc[data-bron]');
    if (doos && !window.QSQ_CHARTS && !document.getElementById('qtl-sc-bron')) {
      var s = document.createElement('script');
      s.id = 'qtl-sc-bron';
      s.src = doos.getAttribute('data-bron');
      document.head.appendChild(s);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
